import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=967161e8&scoped=true"
import script from "./Info.vue?vue&type=script&setup=true&lang=js"
export * from "./Info.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Info.vue?vue&type=style&index=0&id=967161e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967161e8",
  null
  
)

export default component.exports